import { dashboardAPI } from "@/services";
import moment from "moment";

// Store the polling interval outside the actions to maintain state
let pollingInterval = null;
let takingsJobInFlight = false;

function startPolling(context) {
  // Clear any existing interval
  if (pollingInterval) {
    clearInterval(pollingInterval);
  }

  const pollInterval = process.env.NODE_ENV === "development" ? 60000 : 60000;
  pollingInterval = setInterval(() => {
    context.dispatch("updateDashboard", "Dashboard polling update");
  }, pollInterval);
}

function stopPolling() {
  if (pollingInterval) {
    clearInterval(pollingInterval);
    pollingInterval = null;
  }
}

function isWithinEventWindow(selectedEvent) {
  if (!selectedEvent || !selectedEvent.startDateTime || !selectedEvent.endDateTime) {
    return false;
  }
  const start = moment(selectedEvent.startDateTime, "YYYYMMDDHHmm");
  const end = moment(selectedEvent.endDateTime, "YYYYMMDDHHmm");
  if (!start.isValid() || !end.isValid()) {
    return false;
  }
  return moment().isBetween(start, end, null, "[]");
}

function populateComponent(
  APICall,
  context,
  setStateData,
  setStateLoading,
  queryParamsContext
) {
  APICall(queryParamsContext)
    .then((response) => {
      context.commit(setStateData, response);
      context.commit(setStateLoading, false);
      console.log(setStateData, response);
    })
    .catch((err) => {
      console.log(`${setStateData.toUpperCase()} component API error`, err);
      context.commit(setStateData, {});
      context.commit(setStateLoading, false);
    });
}

export default {
  startDashboardPolling(context) {
    startPolling(context);
  },

  stopDashboardPolling() {
    stopPolling();
  },

  updateDashboard(context, event) {
    console.log("UPDATE DASHBOARD EVENT:", event);

    // Restart polling on every update
    startPolling(context);

    var selectedEvent = context.rootState.filter.globalEventFilter;
    var eventId = selectedEvent.EventId;

    // Check if this is a polling update and event is more than 7 days old
    if (event === "Dashboard polling update" && selectedEvent.endDateTime) {
      // Parse the date format YYYYMMDDHHmm using moment
      const eventEndDate = moment(
        selectedEvent.endDateTime,
        "YYYYMMDDHHmm"
      ).toDate();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      if (eventEndDate < sevenDaysAgo) {
        console.log(
          "Event is more than 7 days old, stopping polling for updates"
        );
        stopPolling();
        return;
      }
    }

    var searchStartTime = context.rootState.filter.searchStartTime;
    var searchEndTime = context.rootState.filter.searchEndTime;
    var searchStallholders = context.rootState.filter.searchStallholders;
    var searchStalls = context.rootState.filter.searchStalls;

    // If no event id, set the start and end times to not set
    // This returns blank data to display
    if (!eventId) {
      searchEndTime = "notSet";
      searchStartTime = "notSet";
    }
    // If the search end time is the same as the event end time, set it to not set
    // As the query is faster
    if (searchEndTime === selectedEvent.endDateTime) {
      searchEndTime = "notSet";
    }
    if (searchStartTime === selectedEvent.startDateTime) {
      searchStartTime = "notSet";
    }

    // var allStalls = context.rootState.filter.allStalls

    // var stallHolderFilters = context.rootState.filter.filterStallHolders
    // var stallFilters = context.rootState.filter.filterStalls

    // CHANGE HERE:
    // var listOfStalls = context.rootState.filter.globalEventFilter.Stallholders.map(stallHolder => stallHolder.Stalls)
    // var stallFilters = listOfStalls.flat()
    // var stallHolderFilters = context.rootState.filter.globalEventFilter.Stallholders

    // Home page
    var homeAPI = dashboardAPI.getHomeAPI();
    var homeContext = {
      eventId: eventId,
      searchStartTime: searchStartTime,
      searchEndTime: searchEndTime,
    };
    populateComponent(
      homeAPI.getTotals.bind(homeAPI),
      context,
      "setHomeTotals",
      "setHomeTotalsLoading",
      homeContext
    );

    // Product Sales
    var productSalesAPI = dashboardAPI.getProductSalesAPI();
    var productSalesContext = {
      eventId: eventId,
      searchStartTime: searchStartTime,
      searchEndTime: searchEndTime,
      searchStallholders: searchStallholders,
      searchStalls: searchStalls,

      // stallholderStallFilter: stallFilters.length == allStalls.length && stallHolderFilters == 'all' ? 'all-all' : stallFilters.map(x => x.StallholderStall),

      // stalls: stallFilters.map(x => x.StallholderStall)
    };

    populateComponent(
      productSalesAPI.getTotalTransactions.bind(productSalesAPI),
      context,
      "setProductSalesTotalTransactions",
      "setProductSalesTotalTransactionsLoading",
      productSalesContext
    );

    // Takings — submit always; 60s poll only while event is live (live sales)
    const isPollUpdate = event === "Dashboard polling update";
    const shouldFetchTakings =
      !isPollUpdate || isWithinEventWindow(selectedEvent);

    if (shouldFetchTakings && eventId) {
      // Avoid stacking CMC jobs if a previous poll/submit is still running
      if (isPollUpdate && takingsJobInFlight) {
        console.log("Skipping Takings poll — previous job still in flight");
      } else {
        var takingsAPI = dashboardAPI.getTakingsAPI();

        var takingsContext = {
          eventId: eventId,
          searchStartTime: searchStartTime,
          searchEndTime: searchEndTime,
          searchStallholders: searchStallholders,
          searchStalls: searchStalls,
        };

        // Keep existing figures visible on poll refresh (no skeleton wipe)
        const hasExistingTakings =
          !!context.state.takingsTotalSales &&
          Object.keys(context.state.takingsTotalSales).length > 0;

        if (!isPollUpdate || !hasExistingTakings) {
          context.commit("setTakingsTotalSalesLoading", true);
        }
        context.commit(
          "setTakingsJobProgress",
          isPollUpdate ? "Refreshing Takings…" : "Starting Takings job…"
        );

        const onTakingsProgress = (info) => {
          const elapsed = info.elapsedSec || 0;
          const phase = info.phase || info.status || "working";
          let label = isPollUpdate
            ? "Refreshing Takings…"
            : "Generating Takings…";
          if (info.status === "PENDING" || phase === "queued") {
            label = isPollUpdate ? "Refreshing Takings…" : "Takings queued…";
          } else if (phase === "aggregating") {
            label = "Aggregating Takings…";
          } else if (phase === "saving") {
            label = "Saving Takings result…";
          } else if (info.status === "RUNNING") {
            label = isPollUpdate
              ? "Refreshing Takings…"
              : "Generating Takings…";
          }
          context.commit(
            "setTakingsJobProgress",
            `${label} (${elapsed}s)`
          );
        };

        takingsJobInFlight = true;
        takingsAPI
          .getTotalSales(takingsContext, onTakingsProgress)
          .then((response) => {
            if (
              context.rootState.filter.globalEventFilter?.EventId &&
              context.rootState.filter.globalEventFilter.EventId !== eventId
            ) {
              return;
            }
            context.commit("setTakingsTotalSales", response);
            context.commit("setTakingsTotalSalesLoading", false);
            context.commit("setTakingsJobProgress", "");
          })
          .catch((err) => {
            console.log("setTakingsTotalSales component API error", err);
            // On poll failure keep prior figures; only clear on explicit submit errors
            if (!isPollUpdate) {
              context.commit("setTakingsTotalSales", {});
            }
            context.commit("setTakingsTotalSalesLoading", false);
            context.commit("setTakingsJobProgress", "");
          })
          .finally(() => {
            takingsJobInFlight = false;
          });
      }
    }

    // Devices health — refresh on submit and on 60s poll while event is active
    const shouldFetchDevices =
      event !== "Dashboard polling update" ||
      isWithinEventWindow(selectedEvent);

    if (shouldFetchDevices && eventId) {
      var devicesAPI = dashboardAPI.getDevicesAPI();
      context.commit("setDevicesHealthLoading", true);
      populateComponent(
        devicesAPI.getDevicesHealth.bind(devicesAPI),
        context,
        "setDevicesHealth",
        "setDevicesHealthLoading",
        { eventId: eventId }
      );
    }

    // Transactions — Submit-only on Transactions page (no auto-fetch / polling)
    // Previously: context.dispatch("getTransactions");
  },

  /**
   * Search transactions with exclusive filter mode a|b|c.
   * Paginated for all modes: pass { append: true } to load the next page.
   * Does not run from updateDashboard polling.
   */
  searchTransactions(context, options = {}) {
    const append = !!(options && options.append);
    const manageLoading = !options || options.manageLoading !== false;
    const filter = context.rootState.filter;
    const selectedEvent = filter.globalEventFilter;
    const eventId = selectedEvent && selectedEvent.EventId;
    if (!eventId) {
      return Promise.reject(new Error("No event selected"));
    }

    const transactionId = (filter.transactionId || "").trim();
    const deviceId = (filter.deviceId || "").trim();
    const stan = (filter.stan || "").trim();
    const totalAmount = filter.totalAmount;

    let filterMode = "a";
    if (transactionId) {
      filterMode = "c";
    } else if (deviceId) {
      filterMode = "b";
    }

    const asOne = (val) => {
      if (!val || val === "notSet") return null;
      if (Array.isArray(val)) return val.filter(Boolean)[0] || null;
      return val;
    };

    const transactionsContext = {
      eventId,
      filterMode,
      searchStartTime: filter.searchStartTime,
      searchEndTime: filter.searchEndTime,
      searchStallholders: asOne(filter.searchStallholders),
      searchStalls: asOne(filter.searchStalls),
      searchTerminals: asOne(filter.searchTerminals),
      deviceId,
      stan,
      totalAmount,
      transactionId,
    };

    if (append) {
      const nextKey = context.state.transactionsLastEvaluatedKey;
      if (!nextKey) {
        return Promise.resolve({
          rows: context.state.transactionsTransactions || [],
          appended: [],
          lastEvaluatedKey: null,
          hasMore: false,
        });
      }
      transactionsContext.exclusiveStartKey = nextKey;
    }

    if (manageLoading) {
      context.commit("setTransactionsLoading", true);
    }
    return dashboardAPI
      .getTransactionsAPI()
      .getTransactions(transactionsContext)
      .then((response) => {
        // New shape: { items, lastEvaluatedKey }. Legacy: bare array.
        let rows = [];
        let lastEvaluatedKey = null;
        if (Array.isArray(response)) {
          rows = response;
        } else if (response && typeof response === "object") {
          rows = Array.isArray(response.items) ? response.items : [];
          lastEvaluatedKey = response.lastEvaluatedKey || null;
        }

        if (append) {
          context.commit("appendTransactionsTransactions", rows);
        } else {
          context.commit("setTransactionsTransactions", rows);
        }
        context.commit("setTransactionsLastEvaluatedKey", lastEvaluatedKey);

        const all = context.state.transactionsTransactions || [];
        return {
          rows: all,
          appended: rows,
          lastEvaluatedKey,
          hasMore: !!lastEvaluatedKey,
        };
      })
      .catch((err) => {
        console.error("searchTransactions error", err);
        if (!append) {
          context.commit("setTransactionsTransactions", []);
          context.commit("setTransactionsLastEvaluatedKey", null);
        }
        throw err;
      })
      .finally(() => {
        if (manageLoading) {
          context.commit("setTransactionsLoading", false);
        }
      });
  },

  getTransactions(context) {
    // Legacy helper — prefer searchTransactions for the Transactions page
    return context.dispatch("searchTransactions");
  },

  getReports(context, payload) {
    const api = dashboardAPI.getReportsAPI();
    return api.getReports(payload).then((response) => {
      console.log("Starting actions.js getReports");
      return response;
    });
  },

  prepareReport(context, reportType) {
    var selectedEvent = context.rootState.filter.globalEventFilter;

    var searchStartTime = context.rootState.filter.searchStartTime;
    var searchEndTime = context.rootState.filter.searchEndTime;

    // If the search end time is the same as the event end time, set it to not set
    // As the query is faster
    if (searchEndTime === selectedEvent.endDateTime) {
      searchEndTime = "notSet";
    }
    if (searchStartTime === selectedEvent.startDateTime) {
      searchStartTime = "notSet";
    }

    const report = {
      reportType: reportType, //takingsReport
      requestItems: {
        stallholders: context.rootState.filter.searchStallholders,
        stalls: context.rootState.filter.searchStalls,
        eventId: context.rootState.filter.globalEventFilter.EventId,
      },
    };

    if (searchStartTime != "notSet") {
      report.requestItems.startTime = searchStartTime;
    }
    if (searchEndTime != "notSet") {
      report.requestItems.endTime = searchEndTime;
    }

    return report;
  },
};
